/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";

import * as url from "helper/UrlHelper";
import { assetImages } from "constants";

const SentInviteTab = ({ inviteList }) => {
  return (
    <div className="notification_inner">
      <div className="post_item">
        {inviteList.map((inviteData, index) => {
          return (
            <div
              className="white_shadow_bx people_bx bg_white rounded-10 p-3"
              key={index}
            >
              <div className="d-flex align-items-center justify-content-between">
                <div className="left_people d-flex gap-3">
                  <div className="people_profile rounded-circle overflow-hidden">
                    <img
                      src={
                        inviteData.memberimage == ""
                          ? assetImages.defaultUser
                          : url.SERVER_URL + inviteData.memberimage
                      }
                      alt=""
                    />
                  </div>
                  <div className="people_profile_info">
                    <h3>{inviteData.membername}</h3>
                    <h5>{inviteData.memberposition}</h5>
                    <h5>{inviteData.membercompany}</h5>
                    {/* <div className="event_tags">
                      <ul className="list_style_none mb-0">
                        <li>
                          <i className="material-icons-outlined ornge_icon">
                            star
                          </i>
                          <span className="rating">
                            4.5 <em>(32)</em>
                          </span>
                        </li>
                      </ul>
                    </div> */}
                  </div>
                </div>
                <div className="right_people_btn">
                  <Link to="#" className="btn gray_btn accepted_btn">
                    <i className="material-icons">
                      {inviteData.memberstatus == "1" ? "check_circle" : "info"}{" "}
                    </i>
                    <span>
                      {inviteData.memberstatus == "1" ? "Accepted" : "Pending"}
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          );
        })}

        {inviteList.length == 0 ? (
          <p className="text-primary mt-4 fs-sm fw-medium text-uppercase">
            No request sent
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default SentInviteTab;
